import type { JournalEntry } from "@/types/bankReconciliation";
import type { Currency } from "@/types";
import { JOURNAL_DRAG_TYPE } from "./BankTransactionRow";
import { TransactionSpreadsheetRow } from "./TransactionSpreadsheetRow";

type Props = {
  item: JournalEntry;
  selected?: boolean;
  isDragging?: boolean;
  readOnly?: boolean;
  onSelect?: () => void;
  onDragStart?: () => void;
  onDragEnd?: () => void;
};

export function JournalEntryRow({
  item,
  selected = false,
  isDragging = false,
  readOnly = false,
  onSelect,
  onDragStart,
  onDragEnd,
}: Props) {
  const currency = item.currency as Currency;
  const subtitle = [item.accountName, item.reference].filter(Boolean).join(" · ");

  return (
    <div
      draggable={!readOnly}
      role={readOnly ? undefined : "button"}
      tabIndex={readOnly ? undefined : 0}
      onClick={readOnly ? undefined : onSelect}
      onKeyDown={
        readOnly
          ? undefined
          : (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onSelect?.();
              }
            }
      }
      onDragStart={
        readOnly
          ? undefined
          : (event) => {
              event.dataTransfer.setData(JOURNAL_DRAG_TYPE, item.id);
              event.dataTransfer.setData("text/plain", item.id);
              event.dataTransfer.effectAllowed = "move";
              onDragStart?.();
            }
      }
      onDragEnd={readOnly ? undefined : onDragEnd}
      className={`h-full transition ${
        readOnly
          ? ""
          : selected
            ? "cursor-grab active:cursor-grabbing"
            : isDragging
              ? "cursor-grab opacity-50 active:cursor-grabbing"
              : "cursor-grab hover:bg-slate-50/80 active:cursor-grabbing"
      }`}
    >
      <TransactionSpreadsheetRow
        description={item.description}
        date={item.date}
        amount={item.amount}
        currency={currency}
        subtitle={subtitle || null}
        highlight={selected}
      />
    </div>
  );
}
